//获取cookie、
export function getCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	arr = document.cookie.match(reg);
	if (arr)
		return (arr[2]);
	else
		return false;
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie(c_name, value, expiredays) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate() + expiredays);
	document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}

//删除cookie
export function delCookie(name) {
	var exp = new Date();
	exp.setTime(exp.getTime() - 1);
	var cval = getCookie(name);
	if (!cval)
		document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

export function getUUID() {
	var d = new Date().getTime();
	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
	return uuid;
}

function resizeImage(url, maxwidth = 800, maxheight = 800, opt = 'contain') {
	var img = new Image(); //提供给canvas使用
	img.src = url;
	return new Promise((resolve, reject) => {
		img.onload = (image) => {
			console.log(image)
			var canvas = document.createElement('canvas');
			let context = canvas.getContext('2d');

			var img_width = maxwidth,
				img_height = maxheight;
			if (opt == 'contain') {
				if (img.width * img_height >= img.height * img_width) {
					if (img.width > img_width) {
						//需要缩放
						img_height = (img.height * img_width) / img.width;
					} else {
						resolve(url);
						return;
					}
				} else {
					if (img.height > img_height) {
						//需要缩放
						img_width = (img.width * img_height) / img.height;
					} else {
						resolve(url);
						return;
					}
				}
			}
			console.log(img_width + '---' + img_height);

			canvas.width = img_width;
			canvas.height = img_height;
			context.drawImage(img, 0, 0, img_width, img_height);
			let dataret = canvas.toDataURL('image/jpeg');

			//console.log(dataret);

			resolve(dataret);
		}

		img.onerror = (image) => {
			console.log(image)
			reject(img);
		}
	});
}

export async function doResizeImage(url, maxwidth = 800, maxheight = 800, opt = 'contain') {
	let retdata = await resizeImage(url, maxwidth, maxheight, opt);

	return retdata;
}

export function getIsWxClient() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true;
	}
	return false;
}

export function readFileContent(file, resultType) {
	return new Promise((resolve) => {
		if (resultType === 'file') {
			resolve();
			return;
		}

		const reader = new FileReader();

		reader.onload = (event) => {
			resolve(event.target.result);
		};

		if (resultType === 'dataUrl') {
			reader.readAsDataURL(file);
		} else if (resultType === 'text') {
			reader.readAsText(file);
		}
	});
}
